import React, { useEffect, useState } from "react";
import { callApi } from "../../actions/base";
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core";
import PackageCard from "../packages/PackageCard";
import {HTTP_METHOD} from "../../constants/http";

const useAvailablePackages = () => {
  const [packages, setPackages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleSuccess = ({ data }) => {
    setPackages(data);
    setLoading(false);
  };
  const handleError = error => {
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    const uri = "/packages";
    callApi(uri, null, handleSuccess, handleError, HTTP_METHOD.GET);
  }, []);

  return { packages, loading, error };
};

const AvailablePackages = () => {
  const {
    packages: availablePackages,
    loading,
  } = useAvailablePackages();

  return (
    <Box>
      <Box pb={2} textAlign="center">
        <Typography variant="h5" paragraph>
          Dostępne pakiety zleceń weryfikacyjnych
        </Typography>
      </Box>
      <Grid container>
        {loading ? (
          <CircularProgress />
        ) : (
          <Grid container item spacing={2}>
            {availablePackages.map(p => (
              <Grid key={p.code} item xs={12} sm={6} lg={3}>
                <PackageCard data={p} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default AvailablePackages;
